import React from 'react';
import Modal from './Modal';

const KBD = ({ children }) => (
  <kbd className="inline-flex items-center justify-center min-w-[1.75rem] h-7 px-1.5 border border-app-border rounded bg-app-surface font-mono text-xs text-app-text shadow-sm">
    {children}
  </kbd>
);

// Sequência "g h" → dois KBDs com "then" entre.
const Sequence = ({ keys }) => (
  <span className="inline-flex items-center gap-1">
    {keys.map((k, i) => (
      <React.Fragment key={i}>
        {i > 0 && <span className="text-xs text-app-text-secondary">depois</span>}
        <KBD>{k}</KBD>
      </React.Fragment>
    ))}
  </span>
);

const Row = ({ label, keys }) => (
  <div className="flex items-center justify-between py-2">
    <span className="text-sm text-app-text">{label}</span>
    <Sequence keys={keys} />
  </div>
);

const ShortcutsModal = ({ isOpen, onClose, groups }) => (
  <Modal isOpen={isOpen} onClose={onClose} title="Atalhos de teclado" size="md">
    <div className="space-y-6">
      {groups.map((group) => (
        <section key={group.title}>
          <h3 className="text-xs font-semibold text-app-text-secondary uppercase tracking-wide mb-1">
            {group.title}
          </h3>
          <div className="divide-y divide-app-border">
            {group.items.map((item) => (
              <Row key={item.label} label={item.label} keys={item.keys} />
            ))}
          </div>
        </section>
      ))}
    </div>
  </Modal>
);

export default ShortcutsModal;
